module.exports = __webpack_public_path__ + "img/pending.fef5f355.svg";